<template>
    <div class="surveyContainer">
        <hooper ref="carousel" :vertical="true" :settings="hooperSettings" style="height: 100%" @slide="slideChanged">
            <slide class="slide survey-form" v-for="surveyItem in survey.questions" :key="surveyItem.id">
                <div class="question-step">
                    Question {{ currentSlide+1 }}
                </div>
                <QuestionNPS ref="npstest" v-if="surveyItem.type === 1" v-on:valueChanged="setCurrentValue"
                             :survey="surveyItem"></QuestionNPS>
                <QuestionText v-if="surveyItem.type === 2" :survey="surveyItem"
                              v-on:valueChanged="setCurrentValue"></QuestionText>
            </slide>
            <slide class="slide">
                <QuestionPersonal v-on:valueChanged="setCurrentPersonalInfos"></QuestionPersonal>
            </slide>
        </hooper>
        <div class="nps-navigator">
            <div class="nps-navigator__progress">
                <div class="nps-navigator__progress__bar" v-bind:style="{ width: surveyProgress+'%' }"></div>
            </div>
            <a class="nps-navigator__prev" href="#" v-bind:class="{ disabled: isFirstStep }" v-tap
               v-on:click="prevSlide()">Précédent</a>
            <a class="nps-navigator__close" href="#" v-tap v-on:click="closeSurvey()">Annuler le questionnaire</a>
            <a class="nps-navigator__next" v-if="!isLastStep" href="#" v-tap v-on:click="nextSlide()">
                Suivant
            </a>
            <a class="nps-navigator__next" v-if="isLastStep && !isSubmiting" href="#" v-tap v-on:click="submitSurvey()">
                Valider
            </a>
            <a class="nps-navigator__next" v-if="isLastStep && isSubmiting" href="#" v-tap v-on:click="submitSurvey()">
                <div class="lds-ring" v-if="isSubmiting"><div></div><div></div><div></div><div></div></div> Sauvegarde
            </a>
        </div>
        <div class="lock-screen" v-if="isSubmiting"></div>
    </div>

</template>

<script>
    import {Hooper, Slide} from 'hooper';
    import 'hooper/dist/hooper.css';
    import QuestionNPS from './questions/QuestionNPS.vue'
    import QuestionText from './questions/QuestionText.vue'
    import QuestionPersonal from './questions/QuestionPersonal.vue'
    import { EventBus } from './../../event-bus.js';

    export default {
        name: 'Survey',
        props: ['survey'],
        components: {
            Hooper,
            Slide,
            QuestionNPS,
            QuestionText,
            QuestionPersonal
        },
        computed: {
            surveyProgress: function () {
                return (this.currentSlide + 1) * 100 / this.totalSlides;
            },
            isLastStep: function () {
                if (this.currentSlide === (this.totalSlides - 1)) {
                    return true;
                }
                return false;
            },
            isFirstStep: function () {
                if (this.currentSlide === 0) {
                    return true;
                }
                return false;
            }
        },
        data() {
            return {
                timer: 0,
                responses: [],
                currentResponse: null,
                actionsLog: [],
                isSubmiting: false,
                personalInformations: {},
                currentSlide: 0,
                totalSlides: 0,
                hooperSettings: {
                    centerMode: true,
                    wheelControl: false,
                    touchDrag: false,
                    mouseDrag: false,
                }
            };
        },
        methods: {
            setCurrentValue: function (value, question_id, type) {
                var response = {
                    'question_id': question_id,
                    'question_type': type,
                    'value': value,
                    'elapsed_time': Math.round(this.timer * 100) / 100,
                };
                this.currentResponse = response;

                if (type == 'nps') {
                    this.logActivity(response, 'response_nps_updated');
                }
            },
            setCurrentPersonalInfos: function (form) {
                this.personalInformations = form;
            },
            logActivity(response, type) {
                this.actionsLog.push({...{'action': type}, ...response});
            },
            nextSlide() {
                if (this.currentResponse !== null) {
                    this.responses[this.currentSlide] = this.currentResponse;
                    this.currentResponse = null;
                }

                this.$refs.carousel.slideNext();
            },
            prevSlide() {
                this.$refs.carousel.slidePrev();
            },
            closeSurvey() {
                this.$parent.closeSurvey();
            },
            slideChanged(carousel) {
                this.currentSlide = carousel.currentSlide;
                this.totalSlides = this.$refs.carousel.slidesCount;
            },
            incrementTimer() {
                this.timer = this.timer + 0.1;
            },
            getFormattedDate() {
                var date = new Date();
                var str = date.getFullYear() + "-" + ('0' + (date.getMonth()+1)).slice(-2) + "-" + ('0' + date.getDate()).slice(-2) + " " + ('0' + date.getHours()).slice(-2) + ":" + ('0' + date.getMinutes()).slice(-2) + ":" + ('0' + date.getSeconds()).slice(-2);
                return str;
            },
            submitSurvey() {
                var response = {
                    'survey_id': this.survey.id,
                    'unique_id': '_' + Math.random().toString(36).substr(2, 9),
                    'submitted_at': this.getFormattedDate(),
                    'duration': this.timer,
                    'responses': JSON.parse(JSON.stringify(this.responses)),
                    'personal_informations': JSON.parse(JSON.stringify(this.personalInformations))
                };

                this.isSubmiting = true;

                this.$store.dispatch('surveys/recordSurvey', response);

                EventBus.$on('surveyRecorded', () => {
                    this.isSubmiting = false;
                    this.closeSurvey();
                });

                EventBus.$on('surveyRecordError', () => {
                    this.isSubmiting = false;
                    this.closeSurvey();
                });

                EventBus.$emit('requestSurveySync');
            }
        },
        created() {

        }
        ,
        mounted() {
            // Get number of slides
            this.totalSlides = this.$refs.carousel.slidesCount;
            // Start timer
            window.setInterval(this.incrementTimer, 100);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .question-step{
        font-size: 17px;
        margin-bottom: 10px;
    }

    .lock-screen{
        position: fixed;
        background-color: rgba(255,255,255,.5);
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 3000;
    }

    .lds-ring {
        display: inline-block;
        width: 25px;
        height: 25px;
        margin-right: 12px;
    }
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 20px;
        height: 20px;
        margin: 8px;
        border: 4px solid black;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #28a1c6 transparent transparent transparent;
    }
    .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }
    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }
    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }


    .hooper.is-vertical {
        outline: none;
    }

    .nps-navigator {
        background: #F5F7FB;
        height: 80px;
        display: flex;
        padding: 0px 40px;
        justify-content: space-between;
        align-items: center;

        &__progress {
            width: 100%;
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 4px;
            background: #cccccc;

            &__bar {
                width: 30%;
                background: #28a1c6;
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                transition: width .3s ease-in-out;
            }
        }

        &__next,
        &__prev,
        &__close {
            position: relative;
            &.disabled {
                opacity: 0.5;
            }

            text-transform: uppercase;
            color: black;
            text-decoration: none;
            font-size: 24px;
        }

        &__next,
        &__prev {
            width: 35%;
        }

        &__next {
            text-align: right;
            z-index: 20000;
        }

        &__prev {
            text-align: left;
        }

        &__close {
            font-size: 15px;
        }
    }

    .survey-form {
        display: flex;
        flex-direction: column;
        align-content: center;
        align-items: center;
        justify-content: center;
    }

    .slide {
        background: #F5F7FB;
    }

    .surveyContainer {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 1500;
        padding-top: 73px;
        padding-bottom: 80px;
        background-color: #F5F7FB;
    }

</style>
